export const DoubleArrows = ({ isDarkTheme }) => {
    const color = isDarkTheme ? "#838A85" : "#979B98";
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 5.3335L14.6667 8.00016M14.6667 8.00016L12 10.6668M14.6667 8.00016H1.33334M4.00001 5.3335L1.33334 8.00016M1.33334 8.00016L4.00001 10.6668"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
